import { z } from 'zod';

import { zodExecutionLogSchema } from '../validations';

export const zodExecutionLogResponseSchema = z.object({
  data: z.array(zodExecutionLogSchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number(),
  totalCount: z.number(),
});

export type ExecutionLogResponse = z.infer<
  typeof zodExecutionLogResponseSchema
>;
